import { ICategory } from '@/app/[locale]/_types'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import { useBreakpointValue } from '@chakra-ui/react'

export default function CategoryLink({
  category,
  showImage = false,
  isSeperatePage = false,
}: {
  category: ICategory
  showImage: boolean
  isSeperatePage?: boolean
}) {
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  return isDesktop ? (
    <Desktop category={category} isSeperatePage={isSeperatePage} />
  ) : (
    <Mobile
      category={category}
      showImage={showImage}
      isSeperatePage={isSeperatePage}
    />
  )
}
